import { AbstractControl, ValidatorFn } from "@angular/forms";

import {
  VALIDATION_PASSED,
  ValidationErrorKey,
} from "../../validators/general-validation.";
import { ControlType } from "../base";

import { FormFieldInput, HtmlInputType, InputFormFieldInit } from "./base";

export class FormFieldInputTypeahead<T extends object> extends FormFieldInput {
  public values!: T[];
  public identifier!: string;

  constructor(init: InputFormFieldInit<FormFieldInputTypeahead<T>>) {
    super(init);

    this.values = init.values;
    this.identifier = init.identifier;
    this.validators = [
      valuesValidatorFactory(this.values, this.identifier),
      ...(init.validators || []),
    ];
    super.addErrorMessages({
      [ValidationErrorKey.TYPEAHEAD_OPTIONS]: $localize`Bitte wählen Sie einen gültigen Eingabewert aus.`,
    });

    this.inputType = HtmlInputType.SEARCH;
    this.controlType = ControlType.TYPEAHEAD;
  }
}

function valuesValidatorFactory<T extends object>(
  values: T[],
  identifier: string,
): ValidatorFn {
  return (control: AbstractControl<string, string>) => {
    if (!control.value) {
      return VALIDATION_PASSED;
    }

    return values.find(
      (value) =>
        (value as Record<string, string>)[identifier] === control.value,
    )
      ? VALIDATION_PASSED
      : { [ValidationErrorKey.TYPEAHEAD_OPTIONS]: true };
  };
}
